//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'

// Batches loaded by scrolling before the visitor is asked to continue,
// so the footer stays reachable.
const AUTOLOADS_PER_ROUND = 5
// Start loading this far before the end of the grid.
const PRELOAD_MARGIN = '500px 0px'
const SKELETONS = 12

function compileBatch(html) {
  // The page itself is compiled with [[ ]] delimiters, so text such as a
  // product title with "{{" in it stays text here as well.
  const { render, staticRenderFns } = Vue.compile(html.trim(), { delimiters: ['[[', ']]'] })
  return { render, staticRenderFns }
}

export default {
  name: 'un-products-feed',
  props: {
    url: { type: String, required: true },
    initialCursor: { type: String, default: '' },
  },
  data() {
    return {
      cursor: this.initialCursor || null,
      batches: [],
      loading: false,
      paused: false,
      autoloads: 0,
      skeletons: SKELETONS,
    }
  },
  mounted() {
    if (!('IntersectionObserver' in window)) {
      // Without the observer the button loads every batch.
      this.paused = true
      return
    }
    this.observer = new IntersectionObserver(
      entries => entries.some(entry => entry.isIntersecting) && this.load(),
      { rootMargin: PRELOAD_MARGIN }
    )
    this.watchTrigger()
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    watchTrigger() {
      // Observing anew reports the current position, so a batch too short
      // to push the trigger out of reach loads the next one at once.
      if (!this.observer) return
      if (this.observed) this.observer.unobserve(this.observed)
      this.observed = this.$refs.trigger || null
      if (this.observed) this.observer.observe(this.observed)
    },
    async load() {
      if (this.loading || !this.cursor) return
      this.loading = true
      try {
        const response = await fetch(
          `${this.url}?cursor=${encodeURIComponent(this.cursor)}`,
          { credentials: 'same-origin', headers: { Accept: 'application/json' } }
        )
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const { data, next_cursor: next } = await response.json()
        this.batches.push({ key: this.cursor, component: compileBatch(data) })
        this.cursor = next
        this.autoloads += 1
        if (this.autoloads >= AUTOLOADS_PER_ROUND) this.paused = true
      } catch (error) {
        // The button retries the same batch.
        this.paused = true
      } finally {
        this.loading = false
      }
      await this.$nextTick()
      // Prices of the new cards are formatted by the same handler as on load.
      document.dispatchEvent(new Event('dom-bind'))
      this.watchTrigger()
    },
    more() {
      this.paused = false
      this.autoloads = 0
      this.load()
    },
  },
}
